// extracted by mini-css-extract-plugin
var _1 = "ra-cart-empty";
var _2 = "ra-cart-empty-sidebar";
export { _1 as "cartEmptyCls", _2 as "cartEmptySidebarCls" }
